<template>
  <div class="row">
    <div class="col">
      <h1>{{ title }}</h1>
    </div>
  </div>

  <div class="mb-2">
    <label class="form-label">Код модели</label>
    <Input
      name="code"
      type="text"
      v-model:modelValue="form.code"
      :add_class="errors.code ? 'is-invalid' : ''"
      @clear="clearErr('code')"
      placeholder="например: FJA300"
    />
    <div v-if="errors.code" class="invalid-feedback d-block">{{ errors.code[0] }}</div>
  </div>

  <div class="mb-2">
    <label class="form-label">Модель (отображаемая)</label>
    <Input
      name="model"
      type="text"
      v-model:modelValue="form.model"
      :add_class="errors.model ? 'is-invalid' : ''"
      @clear="clearErr('model')"
      placeholder="например: L.CRUISER W/G 300"
    />
    <div v-if="errors.model" class="invalid-feedback d-block">{{ errors.model[0] }}</div>
  </div>

  <div class="mb-2">
    <label class="form-label">Объём</label>
    <Input
      name="volume"
      type="text"
      v-model:modelValue="form.volume"
      :add_class="errors.volume ? 'is-invalid' : ''"
      @clear="clearErr('volume')"
      placeholder="например: 3,5"
    />
    <div v-if="errors.volume" class="invalid-feedback d-block">{{ errors.volume[0] }}</div>
  </div>

  <div class="mb-2">
    <label class="form-label">Название для доски</label>
    <Input
      name="board_name"
      type="text"
      v-model:modelValue="form.board_name"
      :add_class="errors.board_name ? 'is-invalid' : ''"
      @clear="clearErr('board_name')"
      placeholder="например: L.CRUISER W/G 300 3,5"
    />
    <div v-if="errors.board_name" class="invalid-feedback d-block">{{ errors.board_name[0] }}</div>
  </div>

  <div class="form-check form-switch my-3">
    <input class="form-check-input" type="checkbox" id="isActive" v-model="form.is_active">
    <label class="form-check-label" for="isActive">Активно</label>
  </div>

  <Button
    caption="Сохранить"
    color="btn-green"
    add_class="w-100"
    icon="check"
    @click="save"
  />
</template>

<script>
import Input from "../../../components/Input.vue";
import Button from "../../../components/Button.vue";

export default {
  name: "FormPrice",
  components: { Input, Button },
  props: {
    title: { type: String, default: "" },
    id: { type: Number, default: 0 },
    item: { type: Object, default: null }, // {id, code, model, volume, board_name, is_active}
    errors: { type: Object, default: () => ({}) },
  },
  emits: ["create-to"],
  data() {
    return {
      form: {
        id: 0,
        code: "",
        model: "",
        volume: "",
        board_name: "",
        is_active: true,
      },
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(v) {
        if (v) {
          this.form = {
            id: v.id || 0,
            code: v.code || "",
            model: v.model || "",
            volume: v.volume || "",
            board_name: v.board_name || "",
            is_active: !!v.is_active,
          };
        } else {
          this.form = { id: 0, code: "", model: "", volume: "", board_name: "", is_active: true };
        }
      },
    },
  },
  methods: {
    save() {
      if (!this.form.board_name) {
        const parts = [this.form.model?.trim(), this.form.volume?.trim()].filter(Boolean);
        this.form.board_name = parts.join(" ");
      }
      this.$emit("create-to", { ...this.form });
    },
    clearErr(field) {
      if (this.errors && this.errors[field]) {
        this.errors[field] = "";
      }
    },
  },
};
</script>
